export var SitePeakDemandReportType;
(function (SitePeakDemandReportType) {
    SitePeakDemandReportType["BY_CURRENT_MONTH"] = "byCurrentMonth";
    SitePeakDemandReportType["BY_TIME_FILTER"] = "byTimeFilter";
})(SitePeakDemandReportType || (SitePeakDemandReportType = {}));
export var SensorTemperatureComplianceLevel;
(function (SensorTemperatureComplianceLevel) {
    SensorTemperatureComplianceLevel["Above"] = "above";
    SensorTemperatureComplianceLevel["Below"] = "below";
    SensorTemperatureComplianceLevel["Within"] = "within";
    SensorTemperatureComplianceLevel["NoData"] = "no_data";
})(SensorTemperatureComplianceLevel || (SensorTemperatureComplianceLevel = {}));
export var OrgEnergyReportingPeriod;
(function (OrgEnergyReportingPeriod) {
    OrgEnergyReportingPeriod["CURRENT"] = "accumulatedConsumptionPrEquipmentTypeReportingMonth";
    OrgEnergyReportingPeriod["PREV_MONTH"] = "accumulatedConsumptionPrEquipmentTypePrevMonth";
})(OrgEnergyReportingPeriod || (OrgEnergyReportingPeriod = {}));
